module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "placeholder": "Select Country",
      "filterable": ""
    },
    model: {
      value: (_vm.currentCountry),
      callback: function($$v) {
        _vm.currentCountry = $$v
      },
      expression: "currentCountry"
    }
  }, _vm._l((_vm.countries), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    }, [_c('span', {
      staticClass: "flag"
    }, [_vm._v(_vm._s(item.flag))]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "code"
    }, [_vm._v(_vm._s(item.dial_code))])])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cc57225","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/countries/CountryCodeSelector.vue
// module id = 3195
// module chunks = 3